<template>
  <nav aria-label="Breadcrumb" class="breadcrumb-nav">
    <div class="breadcrumb-placeholder">
      <span class="nav-item">
        <BasicIcon class="w-4 lg:order-1 text-paragraph-light" :name="'house-outline'" />
      </span>
      <template v-for="index in items" :key="index">
        <span class="text-sm"> » </span>
        <SkeletonElementTextLine :width="`${4 + (index * 2)}rem`" />
      </template>
    </div>
  </nav>
</template>

<script setup lang="ts">
interface Props {
  items?: number;
}

withDefaults(defineProps<Props>(), {
  items: 4,
});
</script>

<style scoped lang="postcss">
.breadcrumb-placeholder {
  @apply breadcrumb flex items-center gap-1.5;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
</style>